import { formatCategory } from "../../helpers/Helper";
import Link from "next/link";
import { PropTypes } from "prop-types";
import Sites from "../../constants/Sites";
import styles from './BreadCrumb.module.css';

const BreadCrumb = (props) => {
  BreadCrumb.propTypes = {
    categories: PropTypes.array,
    siteId: PropTypes.number,
  };

  if (props.categories && props.categories.length > 0) {
    //let category = "test"
    let category =
      props.siteId === 6
        ? props.categories[0].Name.toString()
        : Array.isArray(props.categories)
          ? props.categories
          : props.categories.toString();
    let formattedCategory = formatCategory(category);
    category = Array.isArray(category) ? category[0] : category;
    return (
      <>
        {props.siteId === Sites.OPENROADMEDIA ? (
          <ul className={styles.breadcrumbs}>
            <li>
              <Link href={`/`}>
                HOME
              </Link>
            </li>
            <li>
              {typeof category === 'string' && <Link href={`/category/${category?.toLowerCase()}`}>
                {category.toString().toUpperCase()}
              </Link>}
            </li>
          </ul>
        ) : (
          <ul className={styles.breadcrumbs}>
            <li>
              <Link href={`/`}>
                HOME
              </Link>
            </li>
            <li>
              {typeof category === 'string' && <Link href={`/category/${category?.toString().toLowerCase()}`}>
                {formattedCategory.toString().toUpperCase()}
              </Link>}
            </li>
          </ul>
        )}
      </>
    );
  } else {
    return <></>;
  }
};

export default BreadCrumb;
